/**
 * KAUL_CHILD_THEME_Accordion
 * Manages accessible accordion interactions.
 */
class KAUL_CHILD_THEME_Accordion {
    constructor(root) {
        if (!root) return;

        this.root = root;
        this.items = Array.from(this.root.querySelectorAll('[data-accordion-item]'));
        
        if (this.items.length === 0) return;

        this.init();
    }

    init() {
        this.items.forEach((item) => {
            const trigger = item.querySelector('[data-accordion-trigger]');
            const panel = item.querySelector('[data-accordion-panel]');

            if (!trigger || !panel) return;

            trigger.addEventListener('click', (e) => {
                e.preventDefault();
                this.toggleItem(item);
            });
        });
    }

    toggleItem(item) {
        const isOpen = item.classList.contains('is-open');
        const trigger = item.querySelector('[data-accordion-trigger]');
        const panel = item.querySelector('[data-accordion-panel]');

        if (isOpen) {
            this.closeItem(item, trigger, panel);
        } else {
            // Optional: Close others in the same group
            this.closeAllExcept(item);
            this.openItem(item, trigger, panel);
        }
    }

    openItem(item, trigger, panel) {
        item.classList.add('is-open');
        trigger.setAttribute('aria-expanded', 'true');
        panel.setAttribute('aria-hidden', 'false');
    }

    closeItem(item, trigger, panel) {
        item.classList.remove('is-open');
        trigger.setAttribute('aria-expanded', 'false');
        panel.setAttribute('aria-hidden', 'true');
    }

    closeAllExcept(activeItem) {
        this.items.forEach((item) => {
            if (item === activeItem) return;
            
            const trigger = item.querySelector('[data-accordion-trigger]');
            const panel = item.querySelector('[data-accordion-panel]');
            
            if (item.classList.contains('is-open')) {
                this.closeItem(item, trigger, panel);
            }
        });
    }
}

export default KAUL_CHILD_THEME_Accordion;
